/** @jsx jsx */
import { jsx } from '@emotion/react'
import { videoInstitutional } from '../assets/styles/VideoInstitutional.styles'
import { Col, Container, Row } from 'react-bootstrap'
import videoManifestoDesktop from '../assets/video/video-apresentacao-escola-arabe.mp4'
import VideoControlled from './controlledVideo'

const VideoInstitutional = () => {
  return (
    <section id='sobre' css={videoInstitutional}>
      <Container>
        <Row data-aos="fade-down" data-aos-delay="500" className='title-sec'>
            <Col lg={6} md={6} sm={12}>
              <h2>Escola com proposta acolhedora e estrutura <span>integrada à Mesquita de Foz</span></h2>
            </Col>
            <Col lg={1} md={1} sm={12} />
            <Col lg={5} md={5} sm={12}>
              <p>Na Escola Árabe Bertoni, seu filho aprende com excelência acadêmica, em um ambiente que valoriza a tradição, a fé e o pertencimento à comunidade árabe. </p>
            </Col>
          </Row>
        <div data-aos="fade-up" data-aos-delay="400" className='video-institutional'>
          <VideoControlled videoSrcURL={videoManifestoDesktop} />
        </div>
      </Container>
    </section>

  )
}

export default VideoInstitutional
